// @ts-nocheck

export function RomanDivider({ theme }: { theme: string }) {
  return (
    <div className={`roman-divider ${theme}`}>
      <div className="roman-divider-diamond" />
    </div>
  );
}
